import {
  Button, Tooltip,
} from 'antd';
import { object } from 'prop-types';
import { useRequest } from 'ahooks';
import ysq from '@/assets/myApplication/status_ysq.png';
import sptg from '@/assets/myApplication/status_sptg.png';
import blz from '@/assets/myApplication/status_blz.png';
import fkcg from '@/assets/myApplication/status_fkcg.png';
import spwtg from '@/assets/myApplication/status_spwtg.png';
import cancel from '@/assets/myApplication/status_qx.png';
import largeGrainGrowerImg from '@/assets/myApplication/large-grain-grower.png';
import { downloadFile, moneyDelete } from '@/utils/utils';
import { fileDownload } from '@/services/largeGrainGrower';

const statusObj = {
  0: { name: '已提交申请', class: '#3E7EFF', icon: ysq },
  2: { name: '审核中', class: '#3E7EFF', icon: blz },
  3: { name: '已公示', class: '#3E7EFF', icon: sptg },
  4: { name: '审核通过', class: '#12A366', icon: fkcg },
  5: { name: '审核不通过', class: '#E54545', icon: spwtg },
  9: { name: '已取消', class: '#999999', icon: cancel },
};

export default function LargeGrainGrower(props) {
  const { data, onCancel, onSchedule } = props;
  function getDate(e) {
    const day = e.split(' ');
    return day[0];
  }
  // 下载附件
  const { loading, run } = useRequest(fileDownload, {
    manual: true,
    onSuccess: ({ data: fileData, filename }) => {
      downloadFile(fileData, filename);
    },
  });
  return (
    <div className="myapplication__list-row">
      <div className="myapplication__status">
        <img src={statusObj[data.status]?.icon} alt="" width={130} height={35} />
        <span style={{ color: statusObj[data.status]?.class }} className="myapplication__status-text">{statusObj[data.status]?.name}</span>
      </div>
      <div className="myapplication__list-row-img">
        <img src={largeGrainGrowerImg} alt="" width={250} height={75} />
      </div>
      <div className="myapplication__list-row-con" style={{ gridTemplateColumns: '250px 120px 180px 120px 140px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className="myapplication__list-row-name" style={{ alignItems: 'center' }}>
            <Tooltip title={data.applicantName}>
              <span className="myapplication__list-pro-name">{data.applicantName || '-'}</span>
            </Tooltip>
            <span className="tagOrg">种粮大户</span>
          </div>
        </div>
        <div className="margin-right20">
          <div>申报年度</div>
          <div className="myapplication__list-row-title">
            {data.year}
            年
          </div>
        </div>
        <div className="margin-right20">
          <div>申报区域</div>
          <div className="myapplication__list-row-title" style={{ paddingRight: 10 }}>
          {data.applicationArea}
          </div>
        </div>
        <div className="margin-right20">
          {/* <div>补贴金额</div>
          <div className="myapplication__list-row-title">
            {moneyDelete(data.totalVerifySubsidyMoney) === 0 ? '-' : `${getUnitConversionWithRatio(moneyDelete(data.totalVerifySubsidyMoney), 10000)?.num}`}
            {moneyDelete(data.totalVerifySubsidyMoney) === 0 ? '' : `${getUnitConversionWithRatio(moneyDelete(data.totalVerifySubsidyMoney), 10000)?.unit}元`}
          </div> */}
          <div>核实补贴面积</div>
          <div className="myapplication__list-row-title">
            {moneyDelete(data.totalVerifySubsidyArea) === 0 ? '-' : `${data.totalVerifySubsidyArea}亩`}
          </div>
        </div>
        <div className="margin-right20">
          <div>申请时间</div>
          <div className="myapplication__list-row-title">{getDate(data.gmtCreate)}</div>
        </div>
      </div>
      <div style={{ width: 88 }} hidden={data?.status !== 0} />
      <div className="btn-box" style={{ position: data?.status !== 0 ? '' : 'absolute', right: '20px', top: '12px' }}>
        <Button type="primary" onClick={onSchedule}>
          进度查询
        </Button>
        <Button type="primary" ghost onClick={() => run(data?.applicationId)} loading={loading}>
          报表下载
        </Button>
        {
          data?.status < 3 && (
            <Button type="primary" ghost onClick={onCancel}>
              取消申请
            </Button>
          )
        }
      </div>
    </div>
  );
}

LargeGrainGrower.propTypes = {
  data: object,
  onSchedule: () => { },
  onCancel: () => { },
};
